var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvertVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2803 12.9697C12.9874 12.6768 12.5126 12.6768 12.2197 12.9697C11.9268 13.2626 11.9268 13.7374 12.2197 14.0303L15.2197 17.0303C15.5126 17.3232 15.9874 17.3232 16.2803 17.0303L19.2803 14.0303C19.5732 13.7374 19.5732 13.2626 19.2803 12.9697C18.9874 12.6768 18.5126 12.6768 18.2197 12.9697L16.5 14.6893L16.5 7.5C16.5 7.08579 16.1642 6.75 15.75 6.75C15.3358 6.75 15 7.08579 15 7.5L15 14.6893L13.2803 12.9697Z",
    fill: "#081754"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.78033 11.0303C5.48744 11.3232 5.01256 11.3232 4.71967 11.0303C4.42678 10.7374 4.42678 10.2626 4.71967 9.96967L7.71967 6.96967C8.01256 6.67678 8.48744 6.67678 8.78033 6.96967L11.7803 9.96967C12.0732 10.2626 12.0732 10.7374 11.7803 11.0303C11.4874 11.3232 11.0126 11.3232 10.7197 11.0303L9 9.31066V16.5C9 16.9142 8.66421 17.25 8.25 17.25C7.83579 17.25 7.5 16.9142 7.5 16.5L7.5 9.31066L5.78033 11.0303Z",
    fill: "#081754"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertVertical);
export default __webpack_public_path__ + "static/media/invert-vertical.8ddc1c32e52caaf3a9d9532fce2a7a37.svg";
export { ForwardRef as ReactComponent };